if (!customElements.get('product-card-2')) {
  class ProductCard2 extends HTMLElement {
    connectedCallback() {
      this.image = this.querySelector('[data-card2-image]');
      this.colorLabel = this.querySelector('[data-card2-color-label]');
      this.onClick = this.onClick.bind(this);
      this.addEventListener('click', this.onClick);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
    }

    onClick(event) {
      const dot = event.target.closest('[data-card2-dot]');
      if (dot) {
        event.preventDefault();
        this.updateImage(dot);
        this.setActiveDot(dot);
        return;
      }

      const swatch = event.target.closest('[data-card2-swatch]');
      if (swatch) {
        event.preventDefault();
        this.updateImage(swatch);
        this.setSelectedSwatch(swatch);
      }
    }

    updateImage(source) {
      if (!this.image) return;
      const { src, srcset, width, height, alt } = source.dataset;
      if (!src) return;

      this.image.src = src;
      if (srcset) this.image.srcset = srcset;
      if (width) this.image.width = width;
      if (height) this.image.height = height;
      if (typeof alt === 'string') this.image.alt = alt;
    }

    setActiveDot(activeDot) {
      this.querySelectorAll('[data-card2-dot]').forEach((dot) => {
        dot.classList.toggle('is-active', dot === activeDot);
      });
    }

    setSelectedSwatch(activeSwatch) {
      this.querySelectorAll('[data-card2-swatch]').forEach((swatch) => {
        const isSelected = swatch === activeSwatch;
        swatch.classList.toggle('is-selected', isSelected);
        swatch.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
      });

      if (this.colorLabel && activeSwatch.dataset.name) {
        this.colorLabel.textContent = activeSwatch.dataset.name;
      }
    }
  }

  customElements.define('product-card-2', ProductCard2);
}
